import mainService from "services/mainService";

/**
 * @description Valida se já existe algum usuário cadastrado com os campos únicos
 * @param {object} fields - objeto com os campos a serem validados (ex: { email, phone, cnpj, cpf })
 * @coment caso algum dado esteja já esteja cadastrado no banco de dados, será retornado erro 400 e qual campo deu erro
 * @param {boolean} withoutToast
 * @example validateUniqueField({
 *   fields: { phone: "5585998341212", email: "email@teste.com", cnpj: "11111111111" },
 *  withoutToast: true,
 * })
 */
export const validateUniqueField = ({ fields = {}, withoutToast = false }) => {
  const params = Object?.entries(fields)
    ?.map(([key, value]) => `${key}=${value}`)
    ?.join("&");

  return mainService.get(`v2/validation_unique_field?${params}`, {
    headers: { "notifications-front-banned": withoutToast },
  });
};
